import { create } from 'zustand'

const useMenuStore = create((set) => ({
  visible: false,
  setVisible: vis => set({visible: vis}),
}));

export default useMenuStore;